function dateToString(date) {
    return date.toLocaleDateString("en-IN", {
        day: 'numeric',
        month: "long",
        year: 'numeric',
    });
}

export { dateToString };